import { render, staticRenderFns } from "./infoMobile.vue?vue&type=template&id=a0b2994e&scoped=true"
import script from "./infoMobile.vue?vue&type=script&lang=js"
export * from "./infoMobile.vue?vue&type=script&lang=js"
import style0 from "./infoMobile.vue?vue&type=style&index=0&id=a0b2994e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b2994e",
  null
  
)

export default component.exports